import React from 'react';
const ThemeSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M18.3359 19.5002H0.601562V17.2341H18.3359V19.5002ZM1.19271 18.909H17.7448V17.8252H1.19271V18.909Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
      <path
        d="M18.3359 7.73659H0.601562V5.57694L9.46875 1.5L18.3359 5.57694V7.73659ZM1.19271 7.14544H17.7448V5.95527L9.46875 2.15026L1.19271 5.95527V7.14544Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
      <path
        d="M5.13564 16.6531H2.37695V8.31796H5.13564V16.6531ZM2.9681 16.062H4.54449V8.90911H2.9681V16.062Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
      <path
        d="M16.5614 16.6531H13.8027V8.31796H16.5614V16.6531ZM14.3939 16.062H15.9703V8.90911H14.3939V16.062Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
      <path
        d="M5.52735 8.91056H1.98047V7.14697H5.52735V8.91056ZM2.57161 8.31941H4.9362V7.73812H2.57161V8.31941Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
      <path
        d="M16.957 8.91056H13.4102V7.14697H16.957V8.91056ZM14.0013 8.31941H16.3659V7.73812H14.0013V8.31941Z"
        fill="black"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M5.52735 17.8267H1.98047V16.0631H5.52735V17.8267ZM2.57161 17.2356H4.9362V16.6543H2.57161V17.2356Z"
        fill="black"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M16.957 17.8267H13.4102V16.0631H16.957V17.8267ZM14.0013 17.2356H16.3659V16.6543H14.0013V17.2356Z"
        fill="black"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M9.46901 6.31952C8.72023 6.31952 8.10938 5.70867 8.10938 4.95989C8.10938 4.2111 8.72023 3.60025 9.46901 3.60025C10.2178 3.60025 10.8286 4.2111 10.8286 4.95989C10.8286 5.70867 10.2178 6.31952 9.46901 6.31952ZM9.46901 4.18943C9.04536 4.18943 8.70052 4.53426 8.70052 4.95792C8.70052 5.38157 9.04536 5.72641 9.46901 5.72641C9.89267 5.72641 10.2375 5.38157 10.2375 4.95792C10.2375 4.53426 9.89267 4.18943 9.46901 4.18943Z"
        fill="black"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M10.8485 16.6531H8.08984V8.31796H10.8485V16.6531ZM8.68099 16.062H10.2574V8.90911H8.68099V16.062Z"
        fill="black"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M11.2402 8.91056H7.69336V7.14697H11.2402V8.91056ZM8.28451 8.31941H10.6491V7.73812H8.28451V8.31941Z"
        fill="black"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M11.2402 17.8267H7.69336V16.0631H11.2402V17.8267ZM8.28451 17.2356H10.6491V16.6543H8.28451V17.2356Z"
        fill="black"
        stroke="black"
        strokeWidth="0.2"
      />
    </svg>
  );
};

export default ThemeSVG;
